import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logoLogin.png'
import _imports_1 from '@/assets/images/bglogin.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-41200931"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "limiter"
}
const _hoisted_2 = { class: "container-login100" }
const _hoisted_3 = { class: "wrap-login100" }
const _hoisted_4 = { class: "login100-form validate-form text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login100-form-title mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "300"
  })
], -1))
const _hoisted_6 = { class: "form-floating mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_8 = { class: "form-floating input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "senha" }, "Informe a senha", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "icon ion-md-eye",
    id: "eye"
  })
], -1))
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-12 text-center" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-12 text-center" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-12 fw-bold text-center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "col-md-12 fw-bold text-danger text-center"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login100-more img-login" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_20 = {
  key: 1,
  class: "limiter"
}
const _hoisted_21 = { class: "container-login100" }
const _hoisted_22 = { class: "wrap-login100" }
const _hoisted_23 = { class: "login100-form validate-form text-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login100-form-title mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "300"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Esqueceu a sua senha? ")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, " Informe seu e-mail abaixo para iniciar o procedimento de cadastro de uma nova senha ")
], -1))
const _hoisted_27 = { class: "form-floating mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email2" }, "Email", -1))
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = { class: "col-md-12 text-center" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-md-12 text-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = {
  key: 0,
  class: "col-md-12 fw-bold text-center"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "col-md-12 fw-bold text-danger text-center"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login100-more img-login" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_39 = {
  key: 2,
  class: "limiter"
}
const _hoisted_40 = { class: "container-login100" }
const _hoisted_41 = { class: "wrap-login100" }
const _hoisted_42 = { class: "login100-form validate-form text-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login100-form-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "300"
  })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Código de verificação ")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, " Informe o código de verificação que enviamos em seu e-mail ")
], -1))
const _hoisted_46 = { class: "form-floating mb-3" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "codigo" }, "Código de verificação", -1))
const _hoisted_48 = { class: "row mb-2" }
const _hoisted_49 = { class: "col-md-12 text-center" }
const _hoisted_50 = { class: "row mb-2" }
const _hoisted_51 = { class: "col-md-12 text-center" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_53 = { class: "row" }
const _hoisted_54 = {
  key: 0,
  class: "col-md-12 fw-bold text-center"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1))
const _hoisted_56 = {
  key: 1,
  class: "col-md-12 fw-bold text-danger text-center"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login100-more img-login" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_58 = {
  key: 3,
  class: "limiter"
}
const _hoisted_59 = { class: "container-login100" }
const _hoisted_60 = { class: "wrap-login100" }
const _hoisted_61 = { class: "login100-form validate-form text-center" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "login100-form-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "300"
  })
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Cadastrar Nova Senha ")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, " Informe a senha e reconfirme a senha ")
], -1))
const _hoisted_65 = { class: "form-floating mb-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "senha" }, "Senha", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "icon ion-md-eye",
    id: "eye"
  })
], -1))
const _hoisted_68 = { class: "form-floating input-group mb-2" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "senha2" }, "Confirme a senha", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "icon ion-md-eye",
    id: "eye"
  })
], -1))
const _hoisted_71 = { class: "row mb-2" }
const _hoisted_72 = { class: "col-md-12 text-center" }
const _hoisted_73 = { class: "row mb-2" }
const _hoisted_74 = { class: "col-md-12 text-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_76 = { class: "row" }
const _hoisted_77 = {
  key: 0,
  class: "col-md-12 fw-bold text-center"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1))
const _hoisted_79 = {
  key: 1,
  class: "col-md-12 fw-bold text-danger text-center"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login100-more img-login" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))

import { onMounted, reactive } from "vue";
  import { useRouter } from "vue-router";

  //servicos
  import * as serviceUsuario from "@/services/usuariosService";

  //componentes
  import TrataTecla from "@/components/TrataTecla/Index.vue";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {


  //vue
  const router = useRouter();

  let controle = reactive({
    userName: "",
    senha: "",
    codigo: "",
    senhaConfirmacao:"",

    pagina: "login",
    status: "",
    erro: ""
  });


  function login() {

    controle.erro = "";
    controle.status = "Autenticando...";

    serviceUsuario.login(controle.userName, controle.senha)
    .then(r=> {
      controle.status = "Logado";

      setTimeout(() => {
        controle.status = "";
        controle.status = "Logado!";
        router.push({ path: "/" });
      }, 2000);

    })
    .catch(erro => {
      console.log(erro);
      controle.status = "";
      controle.erro  = erro;
    })
  }

  function voltar(pagina: string)
  {
    controle.pagina = pagina;
    controle.erro = "";
    controle.status = "";
  }

  function esqueceuSenha() {
    console.log("esqueceu senha");

    controle.pagina = "email";
    
    setTimeout(() => {
      var el = document.getElementById("email2");
      if (el != undefined)
        el.focus();
    }, 500);
  }

  function enviarEmail() {
    console.log("envia email");

    controle.erro = "";
    controle.status = "Enviando email...";

    serviceUsuario.recuperarSenhaSolicitacao(controle.userName)
    .then(r=> {
      controle.status = "Sucesso! Enviamos um código de verificação no seu e-mail";

      setTimeout(() => {
        controle.pagina = "codigoVerificacao";

        setTimeout(() => {
          var el = document.getElementById("codigo");
          if (el != undefined)
            el.focus();
        }, 500);
      }, 3000);
       

    })
    .catch(erro => {
      console.log(erro);
      controle.status = "";
      controle.erro  = erro;
    })

   
  }


  function validarCodigo() {
    console.log("valida codigo")

    controle.erro = "";
    controle.status = "Verificando código...";

    serviceUsuario.recuperarSenhaValidacao(controle.userName, controle.codigo)
    .then(r=> {
      controle.status = "Sucesso! Código verificado";

      setTimeout(() => {
        controle.pagina = "cadastrarSenha";

        setTimeout(() => {
          var el = document.getElementById("senha");
          if (el != undefined)
            el.focus();
        }, 500);
      }, 3000);
       

    })
    .catch(erro => {
      console.log(erro);
      controle.status = "";
      controle.erro  = erro;
    })

  }

  function cadastrarSenha() {
    console.log("cadastra senha")

    controle.erro = "";
    controle.status = "Cadastrando nova senha...";

    serviceUsuario.recuperarSenhaConfirmacao(controle.userName, controle.codigo, controle.senha, controle.senhaConfirmacao)
    .then(r=> {
      controle.status = "Senha cadastrada com sucesso!";

      setTimeout(() => {
        controle.pagina = "login";

        setTimeout(() => {
          var el = document.getElementById("senha");
          if (el != undefined)
            el.focus();
        }, 500);
      }, 5000);
       

    })
    .catch(erro => {
      console.log(erro);
      controle.status = "";
      controle.erro  = erro;
    })
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TrataTecla, null, {
    default: _withCtx(() => [
      (_unref(controle).pagina == 'login')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      id: "email",
                      type: "text",
                      class: "form-control",
                      name: "email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).userName) = $event)),
                      required: "true",
                      autocomplete: "email",
                      autofocus: "true"
                    }, null, 512), [
                      [_vModelText, _unref(controle).userName]
                    ]),
                    _hoisted_7
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      id: "senha",
                      type: "password",
                      class: "form-control",
                      name: "senha",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).senha) = $event)),
                      required: "true",
                      autocomplete: "current-password"
                    }, null, 512), [
                      [_vModelText, _unref(controle).senha]
                    ]),
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (login()))
                      }, " Login ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", {
                        class: "btn btn-link",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (esqueceuSenha()))
                      }, " Esqueceu sua senha? ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_unref(controle).status != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(controle).erro != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(controle).erro), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_19
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(controle).pagina == 'email')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      id: "email2",
                      type: "text",
                      class: "form-control",
                      name: "email",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).userName) = $event)),
                      required: "true",
                      autocomplete: "email",
                      autofocus: "true"
                    }, null, 512), [
                      [_vModelText, _unref(controle).userName]
                    ]),
                    _hoisted_28
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (enviarEmail()))
                      }, " Enviar ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("a", {
                        class: "btn btn-link",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (voltar('login')))
                      }, [
                        _hoisted_33,
                        _createTextVNode(" Voltar ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (_unref(controle).status != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(controle).erro != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(controle).erro), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_38
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(controle).pagina == 'codigoVerificacao')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _hoisted_44,
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      id: "codigo",
                      type: "text",
                      class: "form-control",
                      name: "codigo",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).codigo) = $event)),
                      required: "true",
                      autocomplete: "codigo",
                      autofocus: "true"
                    }, null, 512), [
                      [_vModelText, _unref(controle).codigo]
                    ]),
                    _hoisted_47
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (validarCodigo()))
                      }, " Validar ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("a", {
                        class: "btn btn-link",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (voltar('login')))
                      }, [
                        _hoisted_52,
                        _createTextVNode(" Voltar ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    (_unref(controle).status != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _hoisted_55,
                          _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(controle).erro != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(controle).erro), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_57
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(controle).pagina == 'cadastrarSenha')
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _hoisted_63,
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, [
                    _withDirectives(_createElementVNode("input", {
                      id: "senha",
                      type: "password",
                      class: "form-control",
                      name: "senha",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(controle).senha) = $event)),
                      required: "true",
                      autofocus: "true"
                    }, null, 512), [
                      [_vModelText, _unref(controle).senha]
                    ]),
                    _hoisted_66,
                    _hoisted_67
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _withDirectives(_createElementVNode("input", {
                      id: "senha2",
                      type: "password",
                      class: "form-control",
                      name: "senha2",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).senhaConfirmacao) = $event)),
                      required: "true"
                    }, null, 512), [
                      [_vModelText, _unref(controle).senhaConfirmacao]
                    ]),
                    _hoisted_69,
                    _hoisted_70
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (cadastrarSenha()))
                      }, " Cadastrar senha ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("a", {
                        class: "btn btn-link",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (voltar('login')))
                      }, [
                        _hoisted_75,
                        _createTextVNode(" Voltar ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    (_unref(controle).status != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                          _hoisted_78,
                          _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(controle).erro != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_unref(controle).erro), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_80
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})